package team.platforma.dictionary_data.database.ai_chapter

import app.cash.sqldelight.coroutines.asFlow
import app.cash.sqldelight.coroutines.mapToList
import kotlinx.coroutines.Dispatchers
import kotlinx.coroutines.flow.Flow
import team.platforma.dictionarydata.database.DictionaryDatabase
import team.platforma.dictionarydata.table.AiChapter

class AiChapterTableImpl(
    private val dictionaryDatabase: DictionaryDatabase
): AiChapterTable {
    override suspend fun addChapter(chapter: AiChapter) {
        dictionaryDatabase.aiChapterQueries.addChapter(chapter.id, chapter.name)
    }

    override suspend fun addChapterList(chapterList: List<AiChapter>) {
        chapterList.forEach {
            dictionaryDatabase.aiChapterQueries.addChapter(it.id, it.name)
        }
    }

    override fun observeAllAiChapter(): Flow<List<AiChapter>> {
        return dictionaryDatabase.aiChapterQueries.selectAll().asFlow().mapToList(Dispatchers.Default)
    }

}